/**
 * 「这一程是不是跑在 App 壳里」—— W6。
 *
 * ⚠⚠ **刻意不装 `@capacitor/core`。** 判断壳环境只需要看一眼协议，
 *   为此在 web 包里引入一个原生桥的依赖，代价是：
 *   浏览器用户也要下载它、`packages/api-client` 的降级纪律（红线第 3 条）多一个缺口、
 *   而且以后每个人都会顺手 `import { Capacitor }` 去做别的判断。
 *   ⚠ 真需要原生能力（相机、推送）时再装，且**只装那一个插件**。
 *
 * ⚠ 判据是 `capacitor:` 协议：`capacitor.config.ts` 里 `server.iosScheme: 'capacitor'`，
 *   于是壳里页面的 origin 是 `capacitor://localhost`。
 *   ⚠ 别用 UA 判：WKWebView 的 UA 和 Mobile Safari 基本一样，判不出来。
 *   ⚠ 也别用 `window.Capacitor` 判：那要等桥注入完，而 `.is-native` 这个类
 *     必须在**首帧之前**加上 —— 晚一帧加，用户会看见橡皮筋回弹闪一下。
 */

/** 壳里页面从 `capacitor://localhost` 起。安卓壳将来是 `https://localhost`，届时再加分支。 */
export function isNativeShell(): boolean {
  try {
    return globalThis.location.protocol === 'capacitor:'
  } catch {
    // 取不到 location（极端沙箱）时按「浏览器」处理 —— 那一支的样式是两边都安全的
    return false
  }
}

/**
 * 给 `<html>` 加 `is-native` 类。壳专用样式靠它生效（见 `styles.css`）。
 *
 * ⚠ 必须在 `createRoot().render()` **之前**调用：那条规则关的是整页橡皮筋回弹，
 *   首帧之后才加，用户已经能拉动页面了。
 * ⚠ 只加类、不做别的：壳与浏览器的差异应当**尽可能只体现在 CSS 上**。
 *   一旦开始按这个布尔值分叉 JS，两条路径就会各自长出 bug，而只有一条会被测到。
 */
export function markNativeShell(): void {
  if (!isNativeShell()) return
  globalThis.document.documentElement.classList.add('is-native')
}
